import './page-banner.scss';
import 'slick-carousel';
import 'magnific-popup';

export default () => {
	// Slick Slider
	$( '.js-banner-slider' ).slick( {
		dots: true,
		arrows: false,
		infinite: false,
		rows: 0,
		swipe: true,
		speed: 400,
		autoplay: true,
		autoplaySpeed: 5000,
	} );

	// Magnific popup
	$( '.page-banner .js-youtube-video' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'mfp-fade',
	} );
};
